import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type Retention = Static<typeof RetentionSchema>;
export const RetentionSchema = Type.Object(
  {
    participants: Type.Object({
      days: Type.Integer({ minimum: 0 }),
    }),
    winners: Type.Object({
      days: Type.Integer({ minimum: 0 }),
    }),
  },
  { additionalProperties: false, $id: 'RetentionSchema' }
);

export type IntegrityCodes = Static<typeof IntegrityCodesSchema>;
export const IntegrityCodesSchema = Type.Union(
  [Type.Literal('contestRules'), Type.Literal('privacyPolicy'), Type.Literal('termsAndConditions')],
  { $id: 'IntegrityCodesSchema' }
);

export type winnerCommunication = Static<typeof winnerCommunicationSchema>;
export const winnerCommunicationSchema = Type.Union(
  [Type.Literal('claim-my-prize'), Type.Literal('email'), Type.Literal('no-communication')],
  {
    $id: 'winnerCommunicationSchema',
  }
);

export type RetailUnit = Static<typeof RetailUnitSchema>;
export const RetailUnitSchema = Type.Object(
  {
    createdAt: Type.Optional(Type.String({ format: 'date-time' })),
    id: Type.String({ minLength: 2, maxLength: 2 }),
    /**
     * List of languages to support for customer-facing parts. This would
     * typically be the same languages as the retail unit have on ikea.com.
     */
    languages: Type.Array(Type.String()),
    defaultLanguage: Type.String(),
    selfService: Type.Object({
      /**
       * List of languages for the self-service portal. This is up to the
       * market to decide what they want.
       */
      languages: Type.Array(Type.String()),
      defaultLanguage: Type.String(),
    }),
    retention: RetentionSchema,
    /** For getting the right format for reatil unit use https://cloud.google.com/looker/docs/reference/param-view-timezone-values*/
    timeZone: Type.String(),
    updatedAt: Type.Optional(Type.String({ format: 'date-time' })),
    currency: Type.String({ minLength: 3, maxLength: 3 }),
    emailTemplate: Type.Object({
      bannerImageUrl: Type.String({ maxLength: 1000 }),
    }),
    /**
     * List of integrity codes matching legal requirements for a specific retail unit. It is up to the
     * market to decide which integrity codes they need to use to be legal compliance.
     */
    integrityCodes: Type.Optional(Type.Array(IntegrityCodesSchema)),
    winnerCommunication: Type.Optional(Type.Array(winnerCommunicationSchema)),
    /**
     * List of lottery types that require customer consent before participation for a specific retail unit.
     */
    lotteryTypeConsents: Type.Optional(Type.Array(Type.Literal('PURCHASE'))),
  },
  { additionalProperties: false, $id: 'RetailUnitSchema' }
);
